/* The liveness panel — OPS-01. Statements with a state against each heading, like the rest of
   /administration. **Nothing is drawn in --ok**: that token means something passed a check, and
   the most this endpoint can say is that nothing is currently raising an alert. Emphasis is the
   warn ramp, and it always travels with a word (design rule 8). */

.body {
  display: grid;
  gap: 14px;
}

.section {
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--panel-2);
  padding: 12px 14px;
}

.head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.title {
  margin: 0;
  font-size: var(--t-dense);
  font-weight: 650;
  color: var(--ink);
}

.chip {
  display: inline-block;
  padding: 1px 6px;
  border: 1px solid var(--line-2);
  border-radius: 999px;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--muted);
}

.chip::first-letter {
  text-transform: uppercase;
}

.attention {
  border-color: var(--warn-line);
  background: var(--warn-w);
  color: var(--warn);
}

.says {
  margin: 6px 0 0;
  font-size: var(--t-min);
  color: var(--muted);
  line-height: 1.5;
}

.facts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  gap: 8px 14px;
  margin: 10px 0 0;
}

.fact {
  display: grid;
  gap: 1px;
}

.factLabel {
  font-size: var(--t-min);
  color: var(--muted);
  text-transform: capitalize;
}

.factValue {
  margin: 0;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--ink);
  overflow-wrap: anywhere;
}

.rows,
.alerts {
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
  font-size: var(--t-min);
}

.rowDetail {
  color: var(--muted);
}

.alert {
  border-left: 2px solid var(--warn-line);
  padding-left: 10px;
}

.code {
  font-size: var(--t-min);
  font-weight: 650;
  color: var(--ink);
  overflow-wrap: anywhere;
}
